export default __webpack_public_path__ + "static/media/16.8bcb988e.png";